import {Component, Input, OnInit} from '@angular/core';
import {Reseller} from "../../models/reseller.model";
import {environment} from "../../../environments/environment";

@Component({
    selector: 'app-reseller',
    templateUrl: './reseller.component.html',
    styleUrls: ['./reseller.component.scss']
})
export class ResellerComponent implements OnInit {
    @Input() reseller: Reseller
    imgUrl = environment.serverImages

    get enviroment() {
        return environment
    }

    constructor() {
    }

    ngOnInit(): void {
    }

}
